import { baseAPI } from "./baseApi";

export const SubscriptionApi = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    getSubscriptionStatus: builder.query({
      query: () => ({ url: "/api/subscription/status" }),
      providesTags: ["Subscription"],
    }),
    createCheckout: builder.mutation({
      query: (payload) => ({
        url: "/api/subscription/create-checkout",
        method: "POST",
        body: payload,
      }),
    }),
    createPortal: builder.mutation({
      query: () => ({
        url: "/api/subscription/create-portal",
        method: "POST",
      }),
    }),
    logConsent: builder.mutation({
      query: (payload) => ({
        url: "/api/subscription/log-consent",
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetSubscriptionStatusQuery,
  useCreateCheckoutMutation,
  useCreatePortalMutation,
  useLogConsentMutation,
} = SubscriptionApi;
